module.exports = __webpack_public_path__ + "static/media/BursariesUpload_Template.3bfec1d3.xlsx";